/**
 * The only file allowed to read `import.meta.env`. Jest swaps it for src/test/env.mock.ts.
 * Empty VITE_* URLs mean "same origin": Vite proxies /api and /_ in dev, Caddy in prod.
 */
export const env = {
  appName: import.meta.env.VITE_APP_NAME || "Quick Planning Poker",
  pocketbaseUrl: import.meta.env.VITE_POCKETBASE_URL || "/",
  /** Your production domain as registered at Plausible. Empty disables analytics. */
  plausibleDomain: import.meta.env.VITE_PLAUSIBLE_DOMAIN || "",
  plausibleHost: import.meta.env.VITE_PLAUSIBLE_HOST || "/pl",
  /** Master switch for ads and the "remove ads" license. Off unless VITE_ADS_ENABLED=true. */
  adsEnabled: import.meta.env.VITE_ADS_ENABLED === "true",
  /** AdSense publisher id (ca-pub-…). Empty: ad slots show the "remove ads" promotion instead. */
  adsenseClient: import.meta.env.VITE_ADSENSE_CLIENT || "",
  /** AdSense ad unit id per placement (components/ads/ad-slot.tsx). */
  adsenseSlots: {
    landing: import.meta.env.VITE_ADSENSE_SLOT_LANDING || "",
    create: import.meta.env.VITE_ADSENSE_SLOT_CREATE || "",
    room: import.meta.env.VITE_ADSENSE_SLOT_ROOM || "",
  },
  isDev: import.meta.env.DEV,
  mode: import.meta.env.MODE,
} as const;
